module.exports = __webpack_public_path__ + "static/media/29EUNOG19.587ed877.jpg";